export default {
  actions: {
    invoiceList(ctx) {
      ctx.commit('updateInvoiceList', [])
    },
    invoiceDirectories(ctx) {
      ctx.commit('updateInvoiceDirectories', null)
    }
  },
  mutations: {
    updateInvoiceList(state, list) {
      state.invoiceList = list
    },
    updateInvoiceDirectories(state, directories) {
      state.invoiceDirectories = directories
    }
  },
  state: {
    invoiceList: [],
    invoiceDirectories: null,
  },
  getters: {
    getInvoiceList(state) {
      return state.invoiceList
    },
    getInvoiceDirectories(state) {
      return state.invoiceDirectories
    }
  }
}